import { MAP, TITLES } from './constants'

export const getGTMProductData = product => {
  const {
    productDisplayName: name,
    skuId: id,
    price,
    brandName: brand,
    skuDisplayName: variant,
    // additional props
    position,
    label
  } = (product || {})

  return {
    name,
    id,
    price,
    brand,
    position: position + 1,
    category: 'Tires',
    variant: variant || 'none',
    list: 'Best Matches on Homepage',
    dimension1: 'In Stock',
    dimension2: label
  }
}

export const getGTMData = (data = {}) =>
  MAP
    .map((category, index) => {
      const productData = getGTMProductData(data[category])

      return productData.id ? {
        ...productData,
        position: index + 1,
        dimension2: TITLES[index]
      } : null
    })
    .filter(Boolean)
